/**
 * Formats the "capcode" description with support for unavailable descriptions
 * @param description The "capcode" description to format
 * @returns The formatted version of the "capcode" description
 */
export const getCapcodeDescription = (description: string | undefined) => {
  const text = description || 'Onbekende capcode';
  return `(${text})`;
};
